import { toDineroOrUndefined } from "../../currency/currencyLib"
import { useMoney } from "../../currency/useMoney"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { useDateTime } from "../../localization/useDateTime"
import { IOrderLine, ISubscriptionDetails } from "../../payments/orderTypes"
import { ReceiptInfoItem, ReceiptSection, ReceiptSkeleton,  } from "./ReceiptBlocks"

type SubscriptionDetailsProps = Readonly<{
    subscription: ISubscriptionDetails | undefined
    orderLines: IOrderLine[] | undefined
}>

export function SubscriptionDetailsSection({ subscription, orderLines }: SubscriptionDetailsProps) {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({})

    // A subscription order will always have exactly 1 order line
    const orderLine = orderLines?.[0]
    const subscriptionPrice = toDineroOrUndefined(orderLine?.price)
    const subscriptionUnit = orderLine?.unit

    return (
        <LocalizedStrict id="receipt-subscription-details-section" attrs={{ heading: true }}>
            <ReceiptSection heading="Abonnement tilmelding">

                <LocalizedStrict id="receipt-subscription-details-subscription-id" attrs={{ label: true }}>
                    <ReceiptInfoItem label="Abonnements-id:">
                        {subscription ? (
                            <span>{subscription.subscriptionId}</span>
                        ) : (
                            <ReceiptSkeleton />
                        )}
                    </ReceiptInfoItem>
                </LocalizedStrict>

                <LocalizedStrict id="receipt-subscription-details-subscription-name" attrs={{ label: true }}>
                    <ReceiptInfoItem label="Abonnementsnavn:">
                        {subscription ? (
                            <span>{subscription.name}</span>
                        ) : (
                            <ReceiptSkeleton />
                        )}
                    </ReceiptInfoItem>
                </LocalizedStrict>

                <LocalizedStrict id="receipt-subscription-details-subscription-valid-from" attrs={{ label: true }}>
                    <ReceiptInfoItem label="Gældende fra:">
                        {subscription ? (
                            <span>
                                {dateTimeFactory.formatDate(
                                    dateTimeFactory.fromApi(subscription.validFrom),
                                )}
                            </span>
                        ) : (
                            <ReceiptSkeleton />
                        )}
                    </ReceiptInfoItem>
                </LocalizedStrict>

                <LocalizedStrict id="receipt-subscription-details-subscription-valid-to" attrs={{ label: true }}>
                    <ReceiptInfoItem label="Gælder til:">
                        {subscription ? (
                            <span>
                                {subscription.validTo ? dateTimeFactory.formatDate(
                                    dateTimeFactory.fromApi(subscription.validTo),
                                ) : '–'}
                            </span>
                        ) : (
                            <ReceiptSkeleton />
                        )}
                    </ReceiptInfoItem>
                </LocalizedStrict>

                <LocalizedStrict id="receipt-subscription-details-subscription-price" attrs={{ label: true }}>
                    <ReceiptInfoItem label="Abonnementspris:">
                        {subscription ? (
                            <>
                                {(subscriptionPrice && subscriptionUnit) ? (
                                    <>{moneyFactory.formatWithUnit(subscriptionPrice, subscriptionUnit)}</>
                                ) : (
                                    <>-</>
                                )}
                            </>
                        ) : (
                            <ReceiptSkeleton />
                        )}
                    </ReceiptInfoItem>
                </LocalizedStrict>
            </ReceiptSection>
        </LocalizedStrict>
    )
}
